/* eslint-disable */

import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useFlutterwave } from 'flutterwave-react-v3';
import {
  useState,
  useMemo,
  useEffect,
  useRef,
  Fragment,
  useCallback,
} from 'react';
import { Modal, notification } from 'antd';
import { Helmet } from 'react-helmet';
import { phone } from 'phone';
import * as Yup from 'yup';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import { useDropzone } from 'react-dropzone';
import Star from '../../assets/icons/Star';
import PhoneInput from 'react-phone-input-2';
import { useReactToPrint } from 'react-to-print';

import Students from '../../assets/icons/Students';
import School from '../../assets/icons/School';
import User from '../../assets/icons/User';

import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';

import logo from '../../assets/images/logo.png';

import camera from '../../assets/images/camera.png';
import inactivecamera from '../../assets/images/inactive-camera.png';
import paw from '../../assets/images/paw.png';
import activePaw from '../../assets/images/active-paw.png';
import human from '../../assets/images/human.png';
import activehuman from '../../assets/images/activehuman.png';
import smile from '../../assets/images/smile.png';
import activesmile from '../../assets/images/activesmile.png';

import lion from '../../assets/images/lion.png';
import owl from '../../assets/images/owl.png';
import fox from '../../assets/images/fox.png';
import whale from '../../assets/images/whale.png';
import butterfly from '../../assets/images/butterfly.png';
import bee from '../../assets/images/bee.png';
import dog from '../../assets/images/dog.png';
import crab from '../../assets/images/crab.png';

import face1 from '../../assets/images/face-1.png';
import face2 from '../../assets/images/face-2.png';
import face3 from '../../assets/images/face-3.png';
import face4 from '../../assets/images/face-4.png';
import face5 from '../../assets/images/face-5.png';
import face6 from '../../assets/images/face-6.png';

import skin1 from '../../assets/images/skin-1.png';
import skin2 from '../../assets/images/skin-2.png';
import skin3 from '../../assets/images/skin-3.png';
import skin4 from '../../assets/images/skin-4.png';
import skin5 from '../../assets/images/skin-5.png';
import skin6 from '../../assets/images/skin-6.png';

import smile1 from '../../assets/images/smile-1.png';
import smile2 from '../../assets/images/smile-2.png';
import smile3 from '../../assets/images/smile-3.png';
import smile4 from '../../assets/images/smile-4.png';

import manskin1 from '../../assets/images/man-skin1.png';
import manskin2 from '../../assets/images/man-skin2.png';
import manskin3 from '../../assets/images/man-skin3.png';
import manskin4 from '../../assets/images/man-skin4.png';
import manskin5 from '../../assets/images/man-skin5.png';
import manskin6 from '../../assets/images/man-skin6.png';

import lady1skin1 from '../../assets/images/lady1-skin1.png';
import lady1skin2 from '../../assets/images/lady1-skin2.png';
import lady1skin3 from '../../assets/images/lady1-skin3.png';
import lady1skin4 from '../../assets/images/lady1-skin4.png';
import lady1skin5 from '../../assets/images/lady1-skin5.png';
import lady1skin6 from '../../assets/images/lady1-skin6.png';

import boyskin1 from '../../assets/images/boy-skin1.png';
import boyskin2 from '../../assets/images/boy-skin2.png';
import boyskin3 from '../../assets/images/boy-skin3.png';
import boyskin4 from '../../assets/images/boy-skin4.png';
import boyskin5 from '../../assets/images/boy-skin5.png';
import boyskin6 from '../../assets/images/boy-skin6.png';

import ballhair1 from '../../assets/images/ballhair-skin1.png';
import ballhair2 from '../../assets/images/ballhair-skin2.png';
import ballhair3 from '../../assets/images/ballhair-skin3.png';
import ballhair4 from '../../assets/images/ballhair-skin4.png';
import ballhair5 from '../../assets/images/ballhair-skin5.png';
import ballhair6 from '../../assets/images/ballhair-skin6.png';

import curlyhair1 from '../../assets/images/curlyhair-skin1.png';
import curlyhair2 from '../../assets/images/curlyhair-skin2.png';
import curlyhair3 from '../../assets/images/curlyhair-skin3.png';
import curlyhair4 from '../../assets/images/curlyhair-skin4.png';
import curlyhair5 from '../../assets/images/curlyhair-skin5.png';
import curlyhair6 from '../../assets/images/curlyhair-skin6.png';

import SecondaryHeader from '../../components/SecondaryHeader/SecondaryHeader';
import Footer from '../../components/Footer/Footer';
import Button from '../../components/Button/Button';
import Upload from '../../assets/icons/Upload';
import man from '../../assets/images/man.png';
import policebadge from '../../assets/images/police-badge.png';
import charity from '../../assets/images/charity.png';
import research from '../../assets/images/research.png';
import economic from '../../assets/images/economic.png';

import UploadAnimation from '../../components/Upload/Upload';

import AssessmentQuestion from '../../components/AssessmentQuestion';
import AssessmentResult from '../../components/AssessmentResult/AssessmentResult';
import WrongIcon from '../../assets/icons/WrongIcon';
import CheckIcon from '../../assets/icons/CheckIcon';
import {
  getClasses,
  getSecurityQuestions,
} from '../../services/waitlistService';
import { register } from '../../services/authService';

import { handleImage } from '../../services/handleImage';
import { saveOrders, updateOrder } from '../../services/paymentService';
import { createUnitLesson } from '../../services/learnService';
import { PUBLIC_KEY } from '../../utils/EditorToolbar';
import Header from '../../components/Header/Header';
import { baseURL } from '../../utils/axios';

const StudentSignup = () => {
  const navigate = useNavigate();
  let sCart = JSON.parse(localStorage.getItem('cart'));
  let values = JSON.parse(localStorage.getItem('newData'));
  const newData = JSON.parse(localStorage.getItem('newData'));

  let productPrice = sCart ? sCart?.map((el) => Number(el.price)) : [];

  let totalProductPrice =
    productPrice.length > 0 ? productPrice.reduce((a, b) => a + b, 0) : 0;

  const emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [avatarModal, setAvatarModal] = useState(false);

  const [confirmVisible, setConfirmVisible] = useState(false);
  const [noVisible, setNoVisible] = useState(false);
  const [successVisible, setSuccessVisible] = useState(false);
  const [activeAvatarType, setActiveAvatarType] = useState('image');
  const [activeTab, setActiveTab] = useState('face');
  const [selectedImage, setSelectedImage] = useState('');
  const [face, setFace] = useState('');
  const [step, setStep] = useState(1);
  const [resultModal, setResultModal] = useState(false);

  const [securityQuestions, setSecurityQuestions] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);

  const [imageUrl, setImageUrl] = useState('');
  const [uploading, setUploading] = useState(false);
  const [imgUploadError, setImgUploadError] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [resultAnalysis, setResultAnalysis] = useState({});
  const [inputDisable, setInputDisable] = useState(false);
  const [validPhone, setValidPhone] = useState(false);
  const [regData, setRegData] = useState({
    age: '',
    class: '',
  });
  const [reference, setReference] = useState('');

  const componentRef = useRef();
  const modalRef = useRef(null);

  //check url params
  let query = new URLSearchParams(useLocation().search);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  let savedSubjects = JSON.parse(localStorage.getItem('subjects'));

  //handle select input
  const handleSelectChange = (evt) => {
    const value = evt.target.value;
    setRegData({
      ...regData,
      [evt.target.name]: value,
    });
  };

  //get security questions on mount
  useEffect(() => {
    async function fetchQuestions() {
      try {
        let res = await getSecurityQuestions();
        setSecurityQuestions(res.data.securityQuestions);
      } catch (error) {
        console.log(error);
      }
    }
    fetchQuestions();
    setReference(`PL-EDV${Date.now()}${Math.floor(Math.random() * 10 + 1)}`);
  }, []);

  useEffect(() => {
    async function fetchClasses() {
      try {
        let res = await getClasses();

        setClasses(res.data.classes);
      } catch (error) {
        console.log(error);
      }
    }
    fetchClasses();
  }, []);

  const config = {
    public_key: PUBLIC_KEY,
    tx_ref: reference,
    amount: totalProductPrice,
    currency: 'NGN',
    payment_options: 'card,mobilemoney,ussd',
    customer: {
      email: values?.email || '',
      phone_number: newData?.phoneNumber || '',
      name: `${newData?.firstName} ${newData?.lastName}` || '',
    },
    customizations: {
      title: 'Personalized Learning by Edves',
      description: 'Payment for items in cart',
      logo: 'https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg',
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  //add student to waitlist
  const regStudent = async () => {
    let values = JSON.parse(localStorage.getItem('newData'));

    //get course ids from local stprage cart

    let courseids = sCart ? sCart?.map((el) => Number(el.id)) : [];
    let data = {
      ...values,
      ageRange: regData.age,
      class: regData.class,
    };

    try {
      setLoading(true);
      let res = await register(data);
      localStorage.setItem('token', res.data.accessToken);
      localStorage.setItem('student', JSON.stringify(res.data.student));

      if (query.get('cart') === 'true') {
        let orderData = {
          courses: courseids,
          paymentGateway: 1,
          reference: reference,
        };
        let response = await saveOrders(
          res.data.student.id,
          orderData,
          res.data.accessToken
        );

        handleFlutterPayment({
          callback: async (response) => {
            let token = localStorage.getItem('token');

            let verifyResponse = await updateOrder(
              res.data.student.id,
              {
                paymentGatewayReference: response.transaction_id,
              },
              token,
              response.tx_ref
            );
            console.log(verifyResponse);

            closePaymentModal(); // this will close the modal programmatically
          },
          onClose: () => {
            setAvatarModal(true);
            setConfirmVisible(false);
            setLoading(false);
            localStorage.removeItem('cart');
          },
        });
      } else {
        setAvatarModal(true);
        setConfirmVisible(false);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      notification['error']({
        message: error.response.data.data.errors.email[0],
      });
      setLoading(false);
    }
  };

  //get assessment questions
  const fetchAssessment = async () => {
    let token = localStorage.getItem('token');
    try {
      const res = await fetch(`${baseURL}/pre-assessments`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      const data = await res.json();

      setQuestions(data.data.preAssessmentQuestions);
    } catch (error) {
      notification['error']({
        message: 'unable to get assessment questions,please try again',
      });
    }
    setStep(step + 1);
  };

  //validate assessment step
  const validateAssessmentStep1 = () => {
    let questions = [];
    for (let index = 0; index < 5; index++) {
      const element = JSON.parse(localStorage.getItem(`question${index + 1}`));
      questions.push(element);
    }
    if (questions.includes(null)) {
      notification['error']({
        message: `Please make sure all questions have been answered`,
      });
    } else {
      setStep(step + 1);
    }
  };

  const validateAssessmentStep2 = () => {
    let questions = [];
    for (let index = 0; index < 10; index++) {
      const element = JSON.parse(localStorage.getItem(`question${index + 1}`));
      questions.push(element);
    }
    if (questions.includes(null)) {
      notification['error']({
        message: `Please make sure all questions have been answered`,
      });
    } else {
      setStep(step + 1);
    }
  };

  const validateAssessmentStep3 = () => {
    let questions = [];
    for (let index = 0; index < 15; index++) {
      const element = JSON.parse(localStorage.getItem(`question${index + 1}`));
      questions.push(element);
    }
    if (questions.includes(null)) {
      notification['error']({
        message: `Please make sure all questions have been answered`,
      });
    } else {
      setStep(step + 1);
    }
  };

  const validateAssessmentStep4 = () => {
    let questions = [];
    for (let index = 0; index < 20; index++) {
      const element = JSON.parse(localStorage.getItem(`question${index + 1}`));
      questions.push(element);
    }
    if (questions.includes(null)) {
      notification['error']({
        message: `Please make sure all questions have been answered`,
      });
    } else {
      setStep(step + 1);
    }
  };

  const validateAssessmentStep5 = () => {
    let questions = [];
    for (let index = 0; index < 25; index++) {
      const element = JSON.parse(localStorage.getItem(`question${index + 1}`));
      questions.push(element);
    }
    if (questions.includes(null)) {
      notification['error']({
        message: `Please make sure all questions have been answered`,
      });
    } else {
      setStep(step + 1);
    }
  };

  //submit assessment
  const getResults = async () => {
    const student = JSON.parse(localStorage.getItem('student'));
    let token = localStorage.getItem('token');

    let questions = [];
    for (let index = 0; index < 30; index++) {
      const element = JSON.parse(localStorage.getItem(`question${index + 1}`));
      questions.push(element);
    }
    if (questions.includes(null)) {
      notification['error']({
        message: `Please make sure all questions have been answered`,
      });
    } else {
      setSubmitLoading(true);
      try {
        let preAssessment = [];
        for (let index = 0; index < 30; index++) {
          const element = JSON.parse(
            localStorage.getItem(`question${index + 1}`)
          );
          preAssessment.push(element);
        }

        const res = await fetch(`${baseURL}/pre-assessments`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json; charset=utf-8',
          },
          body: JSON.stringify({
            student: student.id,
            preAssessment: preAssessment,
          }),
        });

        const data = await res.json();

        setSubmitLoading(false);
        setResultAnalysis(data.data.analysis);
        setResultModal(true);
        setAvatarModal(false);
      } catch (error) {
        console.log(error);
        setSubmitLoading(false);
        notification['error']({
          message: 'Please make sure all questions have been answered',
        });
      }
    }
  };

  let registerData = JSON.parse(localStorage.getItem('registerData'));

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '100%',
  };

  const focusedStyle = {
    borderColor: '#2196f3',
  };

  const acceptStyle = {
    borderColor: '#00e676',
  };

  const rejectStyle = {
    borderColor: '#ff1744',
  };

  //upload image on drop
  const onDrop = useCallback(async (acceptedFiles) => {
    setUploading(true);
    const imagedata = JSON.parse(localStorage.getItem('student'));
    const token = localStorage.getItem('token');

    try {
      let res = await handleImage(acceptedFiles[0], imagedata.id, token);
      setImageUrl(res.data.student.avatar);
      setUploading(false);
    } catch (error) {
      console.log(error);
      setUploading(false);
      setImgUploadError(error);
    }
  }, []);

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({ accept: 'image/*', onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    passwordConfirmation: '',
    securityQuestion: '',
    securityAnswer: '',
  };

  const handleCancel = () => {
    setConfirmVisible(false);
  };

  const handleNoCancel = () => {
    setNoVisible(false);
  };

  const handleSuccessCancel = () => {
    setSuccessVisible(false);
  };

  const handleResultCancel = () => {
    setResultModal(false);
  };

  const handleAvatarCancel = () => {
    setAvatarModal(false);
  };

  const nextPage = () => {
    setStep(step + 1);
    modalRef.current.scrollIntoView();
  };

  //get highest result
  let sortedResult = Object.entries(resultAnalysis).sort((a, b) => b[1] - a[1]);

  return (
    <div>
      <Helmet>
        <title>PL by Edves | Student Signup</title>
      </Helmet>
      <Header />

      <div className='login' style={{ paddingBottom: '120px' }}>
        <div className='login__heading' style={{ paddingTop: '70px' }}>
          <h2>Now let’s setup your account</h2>
          <p>Enter your account details correctly to get started</p>
        </div>

        <div className='user-selection'>
          <div className='user-selection__wrapper'>
            <div
              className={`user-selection__wrapper__selection ${
                window.location.pathname === '/student-signup'
                  ? 'selected-user'
                  : ''
              } `}
              onClick={() => navigate('/student-signup')}
            >
              <Students />
              <p>Student</p>
            </div>

            <div className='user-selection__wrapper__vertical-border'></div>
            <div
              className={`user-selection__wrapper__selection ${
                window.location.pathname === '/school-register' ||
                window.location.pathname === '/schools'
                  ? 'selected-user'
                  : ''
              } `}
              onClick={() => navigate('/school-register')}
            >
              <School />
              <p>School / Tutor</p>
            </div>
          </div>
        </div>

        <div className='login__form' style={{ marginBottom: '10px' }}>
          <div className='auth-wrapper__right__form'>
            <Formik
              initialValues={initialValues}
              validationSchema={Yup.object({
                firstName: Yup.string()
                  .required('Field cannot be empty')
                  .min(2),
                lastName: Yup.string().required('Field cannot be empty').min(2),
                phoneNumber: Yup.string().required('Field cannot be empty'),

                password: Yup.string()
                  .required('Field cannot be empty')
                  .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/,
                    'Must contain 8 characters, One Uppercase, One Lowercase and One Number'
                  ),
                passwordConfirmation: Yup.string()
                  .oneOf([Yup.ref('password'), null], `Password doesn't match`)
                  .required('You need to confirm password'),

                securityQuestion: Yup.string().required(
                  'Field cannot be empty'
                ),
                email: Yup.string()
                  .required('Field cannot be empty')
                  .matches(emailReg, 'Invalid Email'),
                securityAnswer: Yup.string().required('Field cannot be empty'),
              })}
              onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(false);

                const data = {
                  ...values,
                  subjects: [1, 2, 3],
                };
                localStorage.setItem('newData', JSON.stringify(data));
                setConfirmVisible(true);
              }}
            >
              {({ setFieldValue, errors, touched, values }) => (
                <Form>
                  <div className='flex-to-column'>
                    <div
                      className='auth-wrapper__right__form__inputwrapper eye-position'
                      style={{ width: '100%' }}
                    >
                      <label htmlFor='firstName'>First name</label>

                      <Field
                        type='text'
                        name='firstName'
                        id='firstName'
                        placeholder='Enter your first name'
                        className={
                          touched.firstName
                            ? errors.firstName
                              ? 'input-error'
                              : ''
                            : ''
                        }
                      />
                      <div className='eye-icon'>
                        {touched.firstName ? (
                          errors.firstName ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ''
                        )}
                      </div>
                    </div>

                    <div
                      className='auth-wrapper__right__form__inputwrapper eye-position'
                      style={{ width: '100%' }}
                    >
                      <label htmlFor='lastName'>Last name</label>

                      <Field
                        type='text'
                        name='lastName'
                        id='lastName'
                        placeholder='Enter your last name'
                        className={
                          touched.lastName
                            ? errors.lastName
                              ? 'input-error'
                              : ''
                            : ''
                        }
                      />

                      <div className='eye-icon'>
                        {touched.lastName ? (
                          errors.lastName ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>

                  <div className='auth-wrapper__right__form__inputwrapper eye-position'>
                    <label htmlFor='email-address'>Email Address</label>

                    <Field
                      type='email'
                      name='email'
                      id='email-address'
                      placeholder='Enter Email Address'
                      className={
                        touched.email ? (errors.email ? 'input-error' : '') : ''
                      }
                    />
                    <div className='eye-icon'>
                      {touched.email ? (
                        errors.email ? (
                          <WrongIcon />
                        ) : (
                          <CheckIcon />
                        )
                      ) : (
                        ''
                      )}
                    </div>
                  </div>

                  <div className='auth-wrapper__right__form__inputwrapper eye-position'>
                    <label htmlFor='email'>Phone Number</label>

                    <PhoneInput
                      country={'ng'}
                      name='phoneNumber'
                      // onChange={(val) => setFieldValue("phone", val)}
                      onChange={(value) => {
                        setFieldValue('phoneNumber', value);
                        let res = phone(value, { country: 'NG' });
                        setValidPhone(res.isValid);
                      }}
                      className={
                        touched.phoneNumber
                          ? errors.phoneNumber || !validPhone
                            ? 'input-error'
                            : ''
                          : ''
                      }
                    />

                    <div className='eye-icon'>
                      {values.phoneNumber > 4 ? (
                        !validPhone ? (
                          <WrongIcon />
                        ) : (
                          <CheckIcon />
                        )
                      ) : (
                        ''
                      )}
                    </div>
                  </div>

                  <div className='auth-wrapper__right__form__inputwrapper'>
                    <label htmlFor='securityQuestion '>Security Question</label>
                    <div className='auth-wrapper__right__form__selectwrapper'>
                      <Field
                        as='select'
                        name='securityQuestion'
                        id='question'
                        disabled={inputDisable}
                      >
                        <option value=''>Select security question</option>
                        {securityQuestions.length > 0 &&
                          securityQuestions.map((el) => (
                            <Fragment key={el.id}>
                              <option value={el.id}>{el.title}</option>
                            </Fragment>
                          ))}
                      </Field>
                    </div>
                  </div>

                  <div className='auth-wrapper__right__form__inputwrapper eye-position'>
                    <label htmlFor='securityAnswer'>Answer</label>

                    <Field
                      type='text'
                      name='securityAnswer'
                      id='securityAnswer'
                      disabled={inputDisable}
                      placeholder='Enter your answer here'
                      className={
                        touched.securityAnswer
                          ? errors.securityAnswer
                            ? 'input-error'
                            : ''
                          : ''
                      }
                    />

                    <div className='eye-icon'>
                      <div>
                        {touched.securityAnswer ? (
                          errors.securityAnswer ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>

                  <div
                    className='auth-wrapper__right__form__passwordwrapper eye-position'
                    style={{ marginBottom: '10px' }}
                  >
                    <label htmlFor='password'>Password</label>

                    <Field
                      type={showPassword ? 'text' : 'password'}
                      name='password'
                      id='password'
                      disabled={inputDisable}
                      placeholder='Enter your password'
                      className={
                        touched.password
                          ? errors.password
                            ? 'input-error'
                            : ''
                          : ''
                      }
                    />

                    <div className='eye-icon gap-8'>
                      <div>
                        {touched.password ? (
                          errors.password ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ''
                        )}
                      </div>

                      <div onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </div>
                    </div>
                  </div>

                  {touched.password ? (
                    errors.password ? (
                      <p className='password-error'>
                        <ErrorMessage name='password'>
                          {(msg) => msg}
                        </ErrorMessage>
                      </p>
                    ) : (
                      ''
                    )
                  ) : (
                    ''
                  )}

                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ marginBottom: '16px' }}
                  >
                    <label htmlFor='passwordConfirmation'>
                      Confirm Password
                    </label>

                    <Field
                      type={showConfirmPassword ? 'text' : 'password'}
                      name='passwordConfirmation'
                      id='passwordConfirmation'
                      placeholder='Re-enter your password'
                      disabled={inputDisable}
                      className={
                        touched.passwordConfirmation
                          ? errors.passwordConfirmation
                            ? 'input-error'
                            : ''
                          : ''
                      }
                    />

                    <div className='eye-icon gap-8'>
                      <div>
                        {touched.passwordConfirmation ? (
                          errors.passwordConfirmation ? (
                            <WrongIcon />
                          ) : (
                            <CheckIcon />
                          )
                        ) : (
                          ''
                        )}
                      </div>
                      <div
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? (
                          <AiOutlineEyeInvisible />
                        ) : (
                          <AiOutlineEye />
                        )}
                      </div>
                    </div>
                  </div>
                  {touched.passwordConfirmation ? (
                    errors.passwordConfirmation ? (
                      <p className='password-error'>Password does not match</p>
                    ) : (
                      ''
                    )
                  ) : (
                    ''
                  )}

                  <div style={{ marginTop: '16px' }}>
                    <Button
                      text={loading ? 'Please wait...' : 'Sign up'}
                      type='submit'
                      className='primary-btn'
                      width='100%'
                      disabled={loading || !validPhone}
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <div className='new-user' style={{ marginBottom: '79px' }}>
          <p>Already a registered user?</p>
          <p className='new-user__second' onClick={() => navigate('/login')}>
            Log in to your account here
          </p>
        </div>
      </div>

      <Footer />

      <Modal
        width={606}
        visible={confirmVisible}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
        keyboard={false}
        maskClosable={false}
      >
        <div style={{ padding: '40px' }}>
          <div className='selected-school-reg__title'>
            <p>Welcome to</p>
            <h2>PL by Edves</h2>
          </div>
          <img src={man} alt='' />
          <div className='selected-school-reg__body'>
            <div className='selected-school-reg__body__story-2'>
              <p>
                <b style={{ color: '#FEA82F', marginRight: '6px' }}>
                  {' '}
                  Hello {newData?.firstName || ''}!
                </b>{' '}
                You made the right choice to join the brightest students all
                over the world to succeed academically against all odds.
              </p>
              <p style={{ marginTop: '12px' }}>
                Before we start showing you around, let’s get to know you
                better. We want to create the best experience for you and match
                you with learning resources that will be of great satisfaction
                to your academic needs.
              </p>
              <p style={{ marginTop: '12px' }}>
                First, tell us how old you are and your class!
              </p>
            </div>
          </div>

          <div
            className='auth-wrapper__right__form__inputwrapper'
            style={{ marginBottom: '32px', marginTop: '24px' }}
          >
            <label htmlFor='age'>How old are you</label>
            <div className='select-box'>
              <select
                name='age'
                id='age'
                onChange={(e) => handleSelectChange(e)}
                value={regData.age}
              >
                <option value=''>Select age</option>
                <option value='0-5 years'>0-5 years</option>
                <option value='6-8 years'>6-8 years</option>
                <option value='9 - 11 years'>9 - 11 years</option>
                <option value='12 - 15 years'>12 - 15 years</option>
                <option value='16 - 18 years'>16 - 18 years</option>
                <option value='18-above years'>18 and above years</option>
              </select>
            </div>
          </div>

          <div
            className='auth-wrapper__right__form__inputwrapper'
            style={{ marginBottom: '32px' }}
          >
            <label htmlFor='class'>What class are you in?</label>
            <div className='select-box'>
              <select
                name='class'
                id='class'
                onChange={(e) => handleSelectChange(e)}
                value={regData.class}
              >
                <option value=''>Select class</option>
                {classes.map((el) => (
                  <option value={el.id}>{el.name}</option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div
          style={{
            paddingBottom: '41px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button
            className='primary-btn'
            text={loading ? 'Please wait...' : "Let's go!"}
            disabled={loading}
            onClick={() => {
              regStudent();
            }}
          />
        </div>
      </Modal>

      <Modal
        width={700}
        visible={avatarModal}
        onOk={handleAvatarCancel}
        onCancel={handleAvatarCancel}
        footer={null}
        maskClosable={false}
      >
        <div className='percentage-wrap' style={{ background: '#F5F5F5' }}>
          <p style={{ color: '#161410' }}>
            {step === 1 ? `0` : (step / 8)?.toFixed(1) * 100}% Complete
          </p>
          <div
            className='percentage-wrap__percentage'
            style={{
              height: '18px',
              width: `${step === 1 ? `0` : (step / 8) * 100}%`,
              background: `${step === 1 ? '#F5F5F5' : '#7cd1b8'}`,
            }}
          ></div>
        </div>
        <div style={{ padding: '40px' }} ref={modalRef}>
          {step === 1 && (
            <>
              {' '}
              <div>
                <div className='selected-school-reg__title'>
                  <h2>Awesome!</h2>
                </div>
                <div className='selected-school-reg__body'>
                  <img src={man} alt='' />
                  <div className='selected-school-reg__body__story-create-profile'>
                    <p>
                      Let’s create your avatar, you can play around with the
                      different options below.
                    </p>
                  </div>
                </div>
              </div>
              <div className='img-placeholder'>
                {selectedImage !== '' ? (
                  <img src={selectedImage} alt='' />
                ) : imageUrl !== '' ? (
                  <img src={imageUrl} alt='' />
                ) : (
                  <svg
                    width='60'
                    height='60'
                    viewBox='0 0 60 60'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M30 14.75C32.9 14.75 35.25 17.1 35.25 20C35.25 22.9 32.9 25.25 30 25.25C27.1 25.25 24.75 22.9 24.75 20C24.75 17.1 27.1 14.75 30 14.75ZM30 37.25C37.425 37.25 45.25 40.9 45.25 42.5V45.25H14.75V42.5C14.75 40.9 22.575 37.25 30 37.25ZM30 10C24.475 10 20 14.475 20 20C20 25.525 24.475 30 30 30C35.525 30 40 25.525 40 20C40 14.475 35.525 10 30 10ZM30 32.5C23.325 32.5 10 35.85 10 42.5V50H50V42.5C50 35.85 36.675 32.5 30 32.5Z'
                      fill='#5A5955'
                    />
                  </svg>
                )}
              </div>
              <div className='img-flex'>
                <div
                  className='img-flex__single-item'
                  onClick={() => {
                    setActiveAvatarType('image');
                    setSelectedImage('');
                  }}
                >
                  {activeAvatarType === 'image' ? (
                    <img src={camera} alt='' />
                  ) : (
                    <img src={inactivecamera} alt='' />
                  )}

                  {activeAvatarType === 'image' ? <b>Image</b> : <p>Image</p>}
                </div>

                <div
                  className='img-flex__single-item'
                  onClick={() => setActiveAvatarType('animal')}
                >
                  {activeAvatarType === 'animal' ? (
                    <img src={activePaw} alt='' />
                  ) : (
                    <img src={paw} alt='' />
                  )}
                  {activeAvatarType === 'animal' ? (
                    <b>Animal</b>
                  ) : (
                    <p>Animal</p>
                  )}
                </div>

                <div
                  className='img-flex__single-item'
                  onClick={() => setActiveAvatarType('human')}
                >
                  {activeAvatarType === 'human' ? (
                    <img src={activehuman} alt='' />
                  ) : (
                    <img src={human} alt='' />
                  )}

                  {activeAvatarType === 'human' ? <b>Human</b> : <p>Human</p>}
                </div>

                <div
                  className='img-flex__single-item'
                  onClick={() => setActiveAvatarType('smile')}
                >
                  {activeAvatarType === 'smile' ? (
                    <img src={activesmile} alt='' />
                  ) : (
                    <img src={smile} alt='' />
                  )}

                  {activeAvatarType === 'smile' ? <b>Emoji</b> : <p>Emoji</p>}
                </div>
              </div>
              <div className='img-selection-area'>
                {activeAvatarType === 'image' && (
                  <div>
                    {uploading ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexDirection: 'column',
                        }}
                      >
                        <UploadAnimation />

                        <p
                          style={{
                            color: '#F71E1E',
                            borderBottom: '2px solid #F71E1E',
                            cursor: 'pointer',
                            textAlign: 'center',
                          }}
                          onClick={() => setUploading(false)}
                        >
                          Cancel
                        </p>
                      </div>
                    ) : (
                      <div className='container'>
                        <div {...getRootProps({ style })}>
                          <input {...getInputProps()} />

                          <p>Drag and drop image or </p>
                          <p className='sec-text'> Upload from your computer</p>
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {activeAvatarType === 'animal' && (
                  <>
                    <div className='animal-section'>
                      <div
                        className={
                          selectedImage === lion
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(lion)}
                      >
                        <img src={lion} alt='' />
                      </div>

                      <div
                        className={
                          selectedImage === owl
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(owl)}
                      >
                        <img src={owl} alt='' />
                      </div>
                      <div
                        className={
                          selectedImage === fox
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(fox)}
                      >
                        <img src={fox} alt='' />
                      </div>
                      <div
                        className={
                          selectedImage === whale
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(whale)}
                      >
                        <img src={whale} alt='' />
                      </div>
                      <div
                        className={
                          selectedImage === butterfly
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(butterfly)}
                      >
                        <img src={butterfly} alt='' />
                      </div>
                      <div
                        className={
                          selectedImage === bee
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(bee)}
                      >
                        <img src={bee} alt='' />
                      </div>
                    </div>

                    <div className='animal-section-2'>
                      <div
                        className={
                          selectedImage === dog
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(dog)}
                      >
                        <img src={dog} alt='' />
                      </div>

                      <div
                        className={
                          selectedImage === crab
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(crab)}
                      >
                        <img src={crab} alt='' />
                      </div>
                    </div>
                  </>
                )}

                {activeAvatarType === 'human' && (
                  <>
                    <div className='human-avatar-tabs'>
                      <p
                        className={
                          activeTab === 'face' ? 'active-humab-tab' : ''
                        }
                        onClick={() => setActiveTab('face')}
                      >
                        Face
                      </p>
                      <p
                        className={
                          activeTab === 'skin' ? 'active-humab-tab' : ''
                        }
                        onClick={() => setActiveTab('skin')}
                      >
                        Skin Color
                      </p>
                    </div>
                    <div className='animal-section'>
                      {activeTab === 'face' ? (
                        <>
                          <div
                            className={
                              selectedImage === face1
                                ? 'animal-section__item selected-img'
                                : 'animal-section__item'
                            }
                            onClick={() => {
                              setSelectedImage(face1);
                              setFace(face1);
                            }}
                          >
                            <img src={face1} alt='' />
                          </div>

                          <div
                            className={
                              selectedImage === face2
                                ? 'animal-section__item selected-img'
                                : 'animal-section__item'
                            }
                            onClick={() => {
                              setSelectedImage(face2);
                              setFace(face2);
                            }}
                          >
                            <img src={face2} alt='' />
                          </div>
                          <div
                            className={
                              selectedImage === face3
                                ? 'animal-section__item selected-img'
                                : 'animal-section__item'
                            }
                            onClick={() => {
                              setSelectedImage(face3);
                              setFace(face3);
                            }}
                          >
                            <img src={face3} alt='' />
                          </div>
                          <div
                            className={
                              selectedImage === face4
                                ? 'animal-section__item selected-img'
                                : 'animal-section__item'
                            }
                            onClick={() => {
                              setSelectedImage(face4);
                              setFace(face4);
                            }}
                          >
                            <img src={face4} alt='' />
                          </div>
                          <div
                            className={
                              selectedImage === face5
                                ? 'animal-section__item selected-img'
                                : 'animal-section__item'
                            }
                            onClick={() => {
                              setSelectedImage(face5);
                              setFace(face5);
                            }}
                          >
                            <img src={face5} alt='' />
                          </div>
                          <div
                            className={
                              selectedImage === face6
                                ? 'animal-section__item selected-img'
                                : 'animal-section__item'
                            }
                            onClick={() => {
                              setSelectedImage(face6);
                              setFace(face6);
                            }}
                          >
                            <img src={face6} alt='' />
                          </div>
                        </>
                      ) : (
                        <>
                          {face === face5 ? (
                            <>
                              <div
                                className={
                                  selectedImage === skin1
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(skin1)}
                              >
                                <img src={skin1} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === skin2
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(skin2)}
                              >
                                <img src={skin2} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === skin3
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(skin3)}
                              >
                                <img src={skin3} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === skin4
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(skin4)}
                              >
                                <img src={skin4} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === skin5
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(skin5)}
                              >
                                <img src={skin5} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === skin6
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(skin6)}
                              >
                                <img src={skin6} alt='' />
                              </div>
                            </>
                          ) : face === face1 ? (
                            <>
                              <div
                                className={
                                  selectedImage === manskin1
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(manskin1)}
                              >
                                <img src={manskin1} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === manskin2
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(manskin2)}
                              >
                                <img src={manskin2} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === manskin3
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(manskin3)}
                              >
                                <img src={manskin3} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === manskin4
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(manskin4)}
                              >
                                <img src={manskin4} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === manskin5
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(manskin5)}
                              >
                                <img src={manskin5} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === manskin6
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(manskin6)}
                              >
                                <img src={manskin6} alt='' />
                              </div>
                            </>
                          ) : face === face2 ? (
                            <>
                              <div
                                className={
                                  selectedImage === lady1skin1
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(lady1skin1)}
                              >
                                <img src={lady1skin1} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === lady1skin2
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(lady1skin2)}
                              >
                                <img src={lady1skin2} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === lady1skin3
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(lady1skin3)}
                              >
                                <img src={lady1skin3} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === lady1skin4
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(lady1skin4)}
                              >
                                <img src={lady1skin4} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === lady1skin5
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(lady1skin5)}
                              >
                                <img src={lady1skin5} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === lady1skin6
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(lady1skin6)}
                              >
                                <img src={lady1skin6} alt='' />
                              </div>
                            </>
                          ) : face === face3 ? (
                            <>
                              <div
                                className={
                                  selectedImage === boyskin1
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(boyskin1)}
                              >
                                <img src={boyskin1} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === boyskin2
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(boyskin2)}
                              >
                                <img src={boyskin2} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === boyskin3
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(boyskin3)}
                              >
                                <img src={boyskin3} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === boyskin4
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(boyskin4)}
                              >
                                <img src={boyskin4} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === boyskin5
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(boyskin5)}
                              >
                                <img src={boyskin5} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === boyskin6
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(boyskin6)}
                              >
                                <img src={boyskin6} alt='' />
                              </div>
                            </>
                          ) : face === face4 ? (
                            <>
                              <div
                                className={
                                  selectedImage === ballhair1
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(ballhair1)}
                              >
                                <img src={ballhair1} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === ballhair2
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(ballhair2)}
                              >
                                <img src={ballhair2} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === ballhair3
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(ballhair3)}
                              >
                                <img src={ballhair3} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === ballhair4
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(ballhair4)}
                              >
                                <img src={ballhair4} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === ballhair5
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(ballhair5)}
                              >
                                <img src={ballhair5} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === ballhair6
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(ballhair6)}
                              >
                                <img src={ballhair6} alt='' />
                              </div>
                            </>
                          ) : face === face6 ? (
                            <>
                              <div
                                className={
                                  selectedImage === curlyhair1
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(curlyhair1)}
                              >
                                <img src={curlyhair1} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === curlyhair2
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(curlyhair2)}
                              >
                                <img src={curlyhair2} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === curlyhair3
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(curlyhair3)}
                              >
                                <img src={curlyhair3} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === curlyhair4
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(curlyhair4)}
                              >
                                <img src={curlyhair4} alt='' />
                              </div>

                              <div
                                className={
                                  selectedImage === curlyhair5
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(curlyhair5)}
                              >
                                <img src={curlyhair5} alt='' />
                              </div>
                              <div
                                className={
                                  selectedImage === curlyhair6
                                    ? 'animal-section__item selected-img'
                                    : 'animal-section__item'
                                }
                                onClick={() => setSelectedImage(curlyhair6)}
                              >
                                <img src={curlyhair6} alt='' />
                              </div>
                            </>
                          ) : (
                            ''
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}

                {activeAvatarType === 'smile' && (
                  <>
                    <div className='animal-section-2'>
                      <div
                        className={
                          selectedImage === smile1
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(smile1)}
                      >
                        <img src={smile1} alt='' />
                      </div>
                      <div
                        className={
                          selectedImage === smile2
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(smile2)}
                      >
                        <img src={smile2} alt='' />
                      </div>
                      <div
                        className={
                          selectedImage === smile3
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(smile3)}
                      >
                        <img src={smile3} alt='' />
                      </div>
                      <div
                        className={
                          selectedImage === smile4
                            ? 'animal-section__item selected-img'
                            : 'animal-section__item'
                        }
                        onClick={() => setSelectedImage(smile4)}
                      >
                        <img src={smile4} alt='' />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </>
          )}

          {step === 2 && (
            <div>
              {' '}
              <div className='selected-school-reg__title'>
                <h2>Great Choice!</h2>
              </div>
              <div
                className='selected-school-reg__body'
                style={{ marginTop: '60px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    position: 'absolute',
                  }}
                >
                  <div className='selected-school-reg__body__name-bar'>
                    <div className='selected-school-reg__body__name-bar__image'>
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      ) : (
                        <img
                          src={selectedImage}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      )}
                    </div>
                    <p style={{ color: '#fff' }}>
                      {newData?.firstName || ''} {newData?.lastName || ''}
                    </p>
                  </div>
                  {/* <img src={man} alt="" /> */}
                </div>
                <div className='selected-school-reg__body__story-4'>
                  <p>
                    We curated some questions to help us know you better and to
                    help you know yourself better. So kindly let us know some of
                    your interests, likes, dislikes, hobbies, motivations, ....
                  </p>
                </div>

                {questions.slice(0, 5)?.map((el) => (
                  <AssessmentQuestion props={el} key={el.id} />
                ))}
              </div>
            </div>
          )}

          {step === 3 && (
            <div>
              {' '}
              <div className='selected-school-reg__title'>
                <h2>Great Choice!</h2>
              </div>
              <div
                className='selected-school-reg__body'
                style={{ marginTop: '60px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    position: 'absolute',
                  }}
                >
                  <div className='selected-school-reg__body__name-bar'>
                    <div className='selected-school-reg__body__name-bar__image'>
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      ) : (
                        <img
                          src={selectedImage}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      )}
                    </div>
                    <p style={{ color: '#fff' }}>
                      {newData?.firstName || ''} {newData?.lastName || ''}
                    </p>
                  </div>
                  {/* <img src={man} alt="" /> */}
                </div>
                <div className='selected-school-reg__body__story-4'>
                  <p>
                    We curated some questions to help us know you better and to
                    help you know yourself better. So kindly let us know some of
                    your interests, likes, dislikes, hobbies, motivations, ....
                  </p>
                </div>

                {questions.slice(5, 10)?.map((el) => (
                  <AssessmentQuestion props={el} key={el.id} />
                ))}
              </div>
            </div>
          )}

          {step === 4 && (
            <div>
              {' '}
              <div className='selected-school-reg__title'>
                <h2>Great Choice!</h2>
              </div>
              <div
                className='selected-school-reg__body'
                style={{ marginTop: '60px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    position: 'absolute',
                  }}
                >
                  <div className='selected-school-reg__body__name-bar'>
                    <div className='selected-school-reg__body__name-bar__image'>
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      ) : (
                        <img
                          src={selectedImage}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      )}
                    </div>
                    <p style={{ color: '#fff' }}>
                      {newData?.firstName || ''} {newData?.lastName || ''}
                    </p>
                  </div>
                  {/* <img src={man} alt="" /> */}
                </div>
                <div className='selected-school-reg__body__story-4'>
                  <p>
                    We curated some questions to help us know you better and to
                    help you know yourself better. So kindly let us know some of
                    your interests, likes, dislikes, hobbies, motivations, ....
                  </p>
                </div>

                {questions.slice(10, 15)?.map((el) => (
                  <AssessmentQuestion props={el} key={el.id} />
                ))}
              </div>
            </div>
          )}

          {step === 5 && (
            <div>
              {' '}
              <div className='selected-school-reg__title'>
                <h2>Great Choice!</h2>
              </div>
              <div
                className='selected-school-reg__body'
                style={{ marginTop: '60px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    position: 'absolute',
                  }}
                >
                  <div className='selected-school-reg__body__name-bar'>
                    <div className='selected-school-reg__body__name-bar__image'>
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      ) : (
                        <img
                          src={selectedImage}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      )}
                    </div>
                    <p style={{ color: '#fff' }}>
                      {newData?.firstName || ''} {newData?.lastName || ''}
                    </p>
                  </div>
                  {/* <img src={man} alt="" /> */}
                </div>
                <div className='selected-school-reg__body__story-4'>
                  <p>
                    We curated some questions to help us know you better and to
                    help you know yourself better. So kindly let us know some of
                    your interests, likes, dislikes, hobbies, motivations, ....
                  </p>
                </div>

                {questions.slice(15, 20)?.map((el) => (
                  <AssessmentQuestion props={el} key={el.id} />
                ))}
              </div>
            </div>
          )}

          {step === 6 && (
            <div>
              {' '}
              <div className='selected-school-reg__title'>
                <h2>Great Choice!</h2>
              </div>
              <div
                className='selected-school-reg__body'
                style={{ marginTop: '60px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    position: 'absolute',
                  }}
                >
                  <div className='selected-school-reg__body__name-bar'>
                    <div className='selected-school-reg__body__name-bar__image'>
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      ) : (
                        <img
                          src={selectedImage}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      )}
                    </div>
                    <p style={{ color: '#fff' }}>
                      {newData?.firstName || ''} {newData?.lastName || ''}
                    </p>
                  </div>
                  {/* <img src={man} alt="" /> */}
                </div>
                <div className='selected-school-reg__body__story-4'>
                  <p>
                    We curated some questions to help us know you better and to
                    help you know yourself better. So kindly let us know some of
                    your interests, likes, dislikes, hobbies, motivations, ....
                  </p>
                </div>

                {questions.slice(20, 25)?.map((el) => (
                  <AssessmentQuestion props={el} key={el.id} />
                ))}
              </div>
            </div>
          )}

          {step === 7 && (
            <div>
              {' '}
              <div className='selected-school-reg__title'>
                <h2>Great Choice!</h2>
              </div>
              <div
                className='selected-school-reg__body'
                style={{ marginTop: '60px' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    position: 'absolute',
                  }}
                >
                  <div className='selected-school-reg__body__name-bar'>
                    <div className='selected-school-reg__body__name-bar__image'>
                      {imageUrl ? (
                        <img
                          src={imageUrl}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      ) : (
                        <img
                          src={selectedImage}
                          alt=''
                          className='selected-school-reg__body__name-bar__image__imgg'
                        />
                      )}
                    </div>
                    <p style={{ color: '#fff' }}>
                      {newData?.firstName || ''} {newData?.lastName || ''}
                    </p>
                  </div>
                  {/* <img src={man} alt="" /> */}
                </div>
                <div className='selected-school-reg__body__story-4'>
                  <p>
                    We want to recommend resources that fit your learning style
                    and academic needs. So kindly let us know some of your
                    interests, likes, dislikes, hobbies, motivations, ....
                  </p>
                </div>

                {questions.slice(25, 30)?.map((el) => (
                  <AssessmentQuestion props={el} key={el.id} />
                ))}
              </div>
            </div>
          )}
        </div>
        <div style={{ borderTop: '1px solid #eeeeee' }}></div>
        <div className='onboarding-modal-footer'>
          <div
            className={'onboarding-modal-footer__arrow-1'}
            onClick={() => {
              setInputDisable(true);
              if (step !== 1) {
                setStep(step - 1);
              } else if (step === 1) {
                navigate('/login');
              } else return;
            }}
          >
            {step !== 1 ? (
              <>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
                    fill='#161410'
                  />
                </svg>
                <p>Back</p>
              </>
            ) : (
              <p onClick={() => navigate('/login')}>Skip</p>
            )}
          </div>
          <div className='onboarding-modal-footer__step-dots'>
            {Array(8)
              .fill(8)
              .map((_, index) => (
                <div
                  className={
                    step === index + 1
                      ? 'onboarding-modal-footer__step-dots__active-step'
                      : step > index + 1
                      ? 'onboarding-modal-footer__step-dots__filled-step'
                      : 'onboarding-modal-footer__step-dots__inactive-step'
                  }
                  key={index}
                ></div>
              ))}
          </div>

          <div>
            {step === 7 ? (
              <button
                className='primary-btn'
                disabled={submitLoading}
                style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                onClick={() => {
                  getResults();
                }}
              >
                {submitLoading ? `Please wait...` : 'Finish'}
              </button>
            ) : (
              <button
                className='primary-btn'
                style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                disabled={loading}
                onClick={() =>
                  step === 1
                    ? fetchAssessment()
                    : step === 2
                    ? validateAssessmentStep1()
                    : step === 3
                    ? validateAssessmentStep2()
                    : step === 4
                    ? validateAssessmentStep3()
                    : step === 5
                    ? validateAssessmentStep4()
                    : step === 6
                    ? validateAssessmentStep5()
                    : step === 7
                    ? validateAssessmentStep6()
                    : nextPage()
                }
              >
                Next
                <svg
                  width='18'
                  height='12'
                  viewBox='0 0 18 12'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M0 7L14.17 7L10.59 10.59L12 12L18 6L12 0L10.59 1.41L14.17 5L0 5V7Z'
                    fill='#161410'
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        width={700}
        visible={resultModal}
        onOk={handleResultCancel}
        onCancel={handleResultCancel}
        footer={null}
      >
        <div className='selected-school-reg'>
          <div className='selected-school-reg__title'>
            <h2>Your Analysis</h2>
          </div>
          <div className='selected-school-reg__body'>
            <div className='selected-school-reg__body__story-analysis'>
              <p>
                This is an analysis of your career choice based off your
                responses. You scored highest in{' '}
                {sortedResult.length > 0 ? sortedResult[0][0] : ''}.
              </p>
              <div
                onClick={handlePrint}
                style={{
                  display: 'flex',
                  marginTop: '10px',
                  color: '#FEA82F',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <p className='download-link'>Download my result</p>
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M12.6663 6H9.99967V2H5.99967V6H3.33301L7.99967 10.6667L12.6663 6ZM7.33301 7.33333V3.33333H8.66634V7.33333H9.44634L7.99967 8.78L6.55301 7.33333H7.33301ZM3.33301 12H12.6663V13.3333H3.33301V12Z'
                    fill='#FEA82F'
                  />
                </svg>
              </div>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '44px',
              flexDirection: 'column',
            }}
          >
            <div className='small-img-wrapper'>
              <img src={policebadge} />
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
              }}
            >
              <div className='small-img-wrapper'>
                <img src={charity} zalt='' />
              </div>
              <div className='result-img-wrapper'>
                <img
                  src={selectedImage !== '' ? selectedImage : imageUrl}
                  alt=''
                />
              </div>
              <div className='small-img-wrapper'>
                <img src={economic} alt='' />
              </div>
            </div>
            <div className='small-img-wrapper'>
              <img src={research} alt='' />
            </div>
          </div>

          <AssessmentResult resultAnalysis={sortedResult} />
          <Button
            className='primary-btn'
            text='Start Learning'
            width='100%'
            onClick={() => {
              setResultModal(false);
              navigate('/login');
            }}
          />
        </div>
      </Modal>

      <Modal
        width={606}
        visible={noVisible}
        onOk={handleNoCancel}
        onCancel={handleNoCancel}
        footer={null}
      >
        <div className='modal-padding'>
          <div className='modal-head' style={{ marginBottom: '32px' }}>
            <div className='confirm-icon-wrapper'>
              <Star />
            </div>
            <h2>Thank you</h2>
            <p>
              We have received your registeration, expect a mail from <br /> us
              soon on how to get started
            </p>
          </div>
          <Button
            text={'Go Back To Home'}
            className='primary-btn'
            width='100%'
            onClick={() => {
              setNoVisible(false);
              navigate('/');
            }}
          />
        </div>
      </Modal>

      <Modal
        width={606}
        visible={successVisible}
        onOk={handleSuccessCancel}
        onCancel={handleSuccessCancel}
        footer={null}
      >
        <div className='modal-padding'>
          <div className='modal-head' style={{ marginBottom: '32px' }}>
            <div className='confirm-icon-wrapper'>
              <Star />
            </div>
            <h2>Thank you</h2>
            <p>
              You have been added to the waitlist, expect a mail from <br /> us
              soon on how to get started
            </p>
          </div>
          <Button
            text={'Go Back To Home'}
            className='primary-btn'
            width='100%'
            onClick={() => {
              setNoVisible(false);
              navigate('/');
            }}
          />
        </div>
      </Modal>

      <div style={{ display: 'none' }}>
        <div className='selected-school-reg' ref={componentRef}>
          <div className='print-out-header'>
            <img src={logo} alt='' />
          </div>
          <div
            className='selected-school-reg__title'
            style={{ padding: '10px 34px' }}
          >
            <h2>Your Analysis</h2>
          </div>
          <div
            className='selected-school-reg__body'
            style={{ padding: '0 34px' }}
          >
            <div className='selected-school-reg__body__story-analysis'>
              <p>
                This is an analysis of your career choice based off your
                responses. You scored highest in{' '}
                {sortedResult.length > 0 ? sortedResult[0][0] : ''}.
              </p>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '18px',
              flexDirection: 'column',
            }}
          >
            <div className='small-img-wrapper'>
              <img src={policebadge} />
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
              }}
            >
              <div className='small-img-wrapper'>
                <img src={charity} zalt='' />
              </div>
              <div className='result-img-wrapper'>
                <img
                  src={selectedImage !== '' ? selectedImage : imageUrl}
                  alt=''
                />
              </div>
              <div className='small-img-wrapper'>
                <img src={economic} alt='' />
              </div>
            </div>
            <div className='small-img-wrapper'>
              <img src={research} alt='' />
            </div>
          </div>
          <div style={{ padding: '0 34px' }}>
            <AssessmentResult resultAnalysis={sortedResult} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentSignup;
